// @flow

import * as React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

type NameMetaTag = {
    name: string,
    content: string,
}

type PropertyMetaTag = {
    property: string,
    content: string,
}

type MetaTag = NameMetaTag | PropertyMetaTag

type SEOProps = {
    title: string,
    description?: string,
    meta?: Array<MetaTag>,
}

export default function SEO({ title, description = "", meta = [] }: SEOProps) {
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        social {
                            twitter
                        }
                    }
                }
            }
        `
    )

    const metaDescription = description || site.siteMetadata.description

    return (
        <>
            <Helmet
                title={title}
                titleTemplate={`%s - SimplyRETS`}
                htmlAttributes={{ lang: "en" }}
                meta={[
                    {
                        name: `description`,
                        content: metaDescription,
                    },
                    {
                        name: `robots`,
                        content: `index, follow`,
                    },
                    {
                        property: `og:title`,
                        content: `${title} - SimplyRETS`,
                    },
                    {
                        property: `og:description`,
                        content: metaDescription,
                    },
                    {
                        property: `og:type`,
                        content: `website`,
                    },
                    {
                        name: `twitter:card`,
                        content: `summary`,
                    },
                    {
                        name: `twitter:creator`,
                        content: site.siteMetadata.social.twitter,
                    },
                    {
                        name: `twitter:title`,
                        content: `${title} - SimplyRETS`,
                    },
                    {
                        name: `twitter:description`,
                        content: metaDescription,
                    },
                ].concat(meta)}>
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
                />
            </Helmet>
        </>
    )
}
